module.exports = __webpack_public_path__ + "static/receive-shifts-update-3c5bc912ffaa1bc1e24e04152cf5e45a.png";